export const FILTERS_URL_PARAM_KEY = 'filters';
export const EMPTY_FILTERS_URL_PART = '__empty';
export const CHECKSUM_SEPARATOR = ';;';
export const DEFAULT_OPERATOR = 'all';

export const FILTERS_TYPE_NAME_MAP = {
  'meta': 'Meta Filters',
  'meta_multival_json': 'Meta Filters'
};